import {Decoder, equal, oneOf} from 'json-bouncer'

export type InquiryOfferStatus =
    | 'requested'
    | 'inApproval'
    | 'approved'
    | 'rejected'
    | 'discarded'
    | 'finished'

export function offerStatusDecoder(): Decoder<InquiryOfferStatus> {
    const requested: InquiryOfferStatus = 'requested'
    const inApproval: InquiryOfferStatus = 'inApproval'
    const approved: InquiryOfferStatus = 'approved'
    const rejected: InquiryOfferStatus = 'rejected'
    const discarded: InquiryOfferStatus = 'discarded'
    const finished: InquiryOfferStatus = 'finished'
    return oneOf([
        equal(requested),
        equal(inApproval),
        equal(approved),
        equal(rejected),
        equal(discarded),
        equal(finished)
    ])
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryOfferStatus.ts